import { ACTIVE_ACCEPTED_STATUSES, CLOSED_LIST_PARAMS } from '@/lib/task-status';

/**
 * TALEP LISTESI SEKMELERI -> SUNUCU FILTRESI (musteri Taleplerim + buro Piyasa).
 *
 * Bilesen DISINDA iki sebeple: (1) saf fonksiyon olarak sinanabilsin
 * (__tests__/tab-params.test.ts) — sekmeler arasi bir kayma ancak boyle yakalanir; (2) liste ile
 * sekme rozeti (useTaskCounts) AYNI eslemeyi kullanmak zorunda, yoksa rozet ile liste ayrisir.
 *
 * `passedTasks` + `taskStatus` ikilisi sunucudaki filtre sozlesmesi (faz listesi + durum listesi,
 * ikisi AND ile birlesir). Durum kumeleri: src/lib/task-status.ts. Piyasa Gecmis'i istisna:
 * `marketTab=history` tek basina gider (asagida).
 */

export const CUSTOMER_REQUEST_TABS = ['openRequests', 'approvedRequests', 'passedRequests'] as const;
export type CustomerRequestTab = (typeof CUSTOMER_REQUEST_TABS)[number];

export const customerRequestTabParams = (tab: CustomerRequestTab): Record<string, string> => {
  if (tab === 'openRequests') return { passedTasks: 'offer,decide', taskStatus: 'new' };
  // KALICI liste (2026-09-07): eskiden `passedTasks: 'payment'` vardi ve kabulden 15 dakika
  // sonra sekme BOSALIYORDU. Durum bazli: kabul edilmis ve henuz kapanmamis her talep burada,
  // odeme/gonderim penceresi yalnizca kartta bir rozet.
  // 'warning' ARTIK DEGIL (2026-09-26): son durum (platform yonetimi cozer) ve burada gunlerce
  // birikiyordu. 'completed' de degil: tamamlanan is bitmis istir. Ikisi de Gecmis'e gider.
  if (tab === 'approvedRequests') return { taskStatus: ACTIVE_ACCEPTED_STATUSES.join(',') };
  // Yalniz faz ('passive') YETMEZ: penceresi dolmus aktif is de 'passive' gelir ve iki sekmede
  // birden gorunurdu. Durum listesi onu disarida birakir.
  return { ...CLOSED_LIST_PARAMS };
};

export const MARKET_TABS = ['openRequests', 'pastRequests'] as const;
export type MarketTab = (typeof MARKET_TABS)[number];

export const marketTabParams = (tab: MarketTab): Record<string, string> => {
  // Sunucu sozlesmesi: passedTasks virgullu faz listesi kabul eder (countDownType
  // beyaz listesi). Acik sekme musteri tarafiyla ayni pencereyi (offer,decide)
  // kullanir ki iki taraf ayni talebi ayni sure boyunca gorsun.
  if (tab === 'openRequests') return { passedTasks: 'offer,decide', taskStatus: 'new' };
  // Gecmis (2026-10-02): artik ACIK OLMAYAN her talep, sonucuyla (`marketOutcome` rozeti) —
  // kapanmislar VE karara baglanmis ama suren isler ('pending' / 'payment_received'). Eskiden
  // kapali faz + kapali durumdu ve karara baglanan talep Piyasa'nin hicbir sekmesinde kalmiyordu.
  // Sunucu sozlesmesi: yalniz `taskPretenderCurrencyUserId` ile, passedTasks/taskStatus'suz.
  return { marketTab: 'history' };
};
